import { IWatrRequest } from '@nkr/models/index';
import { isSelfEmployed } from './employment-type.utils';

export const requiresTaxDocument = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): boolean => isSelfEmployed(data.employmentType);

export const getVerifyTaxStepLabel = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): string => (requiresTaxDocument(data) ? 'Verify SSN & Tax' : 'Verify SSN');

export const getVerifyTaxLoadingMessage = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): string => (requiresTaxDocument(data) ? 'Verifying SSN and tax...' : 'Verifying SSN...');

export const getVerifyTaxSuccessMessage = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile' | 'firstName' | 'lastName'>
): string => {
    const name = `${data.firstName} ${data.lastName}`.trim();
    return requiresTaxDocument(data)
        ? `${name} SSN and tax have been verified.`
        : `${name} SSN has been verified.`;
};

export const getVerifyTaxErrorMessage = (
    data: Pick<IWatrRequest, 'employmentType' | 'taxDocumentFile'>
): string => (requiresTaxDocument(data) ? 'Unable to verify SSN and tax.' : 'Unable to verify SSN.');
